import React from 'react';
import Main from './components/MainComponent';
import './App.css';
import { HashRouter } from 'react-router-dom';

function App() {
  return (
    <HashRouter basename="/">
      <div>
          <Main/>
      </div>
    </HashRouter>
  );
}

export default App;
